import { CrudPage } from "../components/CrudPage";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { formatTanggal } from "../lib/format";

const empty = { nama_produk: "", kategori: "", keterangan: "" };

const columns = [
    { key: "nama_produk", header: "Nama Produk", className: "font-medium text-slate-900" },
    { key: "kategori", header: "Kategori", render: (r) => r.kategori ? (
        <span className="text-[10px] font-semibold uppercase px-2 py-1 rounded-md border bg-teal-50 text-teal-700 border-teal-200">
            {r.kategori}
        </span>
    ) : "-" },
    { key: "keterangan", header: "Keterangan", className: "text-slate-500 max-w-xs truncate" },
    { key: "created_at", header: "Dibuat", render: (r) => formatTanggal(r.created_at), className: "text-slate-500" },
];

const renderForm = (form, setForm) => (
    <div className="space-y-4">
        <div>
            <Label>Nama Produk <span className="text-rose-600">*</span></Label>
            <Input
                data-testid="produk-form-nama"
                value={form.nama_produk}
                onChange={(e) => setForm({ ...form, nama_produk: e.target.value })}
                className="mt-1.5 rounded-xl"
                placeholder="Contoh: Kemeja Lengan Panjang"
            />
        </div>
        <div>
            <Label>Kategori</Label>
            <Input
                data-testid="produk-form-kategori"
                value={form.kategori}
                onChange={(e) => setForm({ ...form, kategori: e.target.value })}
                className="mt-1.5 rounded-xl"
                placeholder="Kemeja / Celana / Kaos"
            />
        </div>
        <div>
            <Label>Keterangan</Label>
            <Textarea
                value={form.keterangan}
                onChange={(e) => setForm({ ...form, keterangan: e.target.value })}
                className="mt-1.5 rounded-xl"
                rows={3}
            />
        </div>
    </div>
);

const validate = (f) => {
    if (!f.nama_produk?.trim()) return "Nama produk wajib diisi";
    return null;
};

export default function ProdukPage() {
    return (
        <CrudPage
            title="Master Produk"
            subtitle="Katalog produk garment (harga per SPK ditentukan pada phase berikutnya)"
            endpoint="/master/produk"
            entityLabel="Produk"
            columns={columns}
            emptyForm={empty}
            renderForm={renderForm}
            validate={validate}
            testidBase="produk"
        />
    );
}
